export enum ProblemListActionTypes {
    UPDATE_LIST = "updateList",
    SET_CURRENT_WEEK = "setCurrentWeek",
    GET_NEXT = "getNext",
    GET_PREV = "getPrev"
}